import {Inject, Injectable} from '@angular/core';
import {CplTag} from '../model/cpl-tag.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseApi, BASE_URL } from '@edl-development/edl-common';

@Injectable()
export class TagApi extends BaseApi {
    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    getTags(portalId: number, searchBy: string) {
        const params = new HttpParams()
            .append('searchBy', this.convertParam(searchBy));

        return this.http.get(this.baseUri + '/tags/' + portalId.toString(), {
            params
        });
    }

    createTag(tag: CplTag) {
        return this.http.post(this.baseUri + '/tag', tag);
    }

    updateTag(tag: CplTag) {
        return this.http.put(this.baseUri + '/tag', tag);
    }

    deleteTag(tag: CplTag) {
        return this.http.request('delete', this.baseUri + '/tag', {
            responseType: 'text',
            body: tag
        });
    }
}